module.exports = __webpack_public_path__ + "r-v3/img/icon_person.f9c80d27.svg";